//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  async fetch() {
    await Promise.all([ 
      this.$store.dispatch('pagesStore/getPage', 'contact')
    ])
  },
  computed: {
    ...mapState({
      pages: ({ pagesStore: {pages} }) => pages
    }),
  },
  components: {
    contact: () => import('~/components/forms/contact.vue')
  },
  head() {
    return {
      title: this.pages.contact && this.pages.contact.seo ? this.pages.contact.seo.title : 'Contact | Info | Meiden van Holland',
      meta: [
        { hid: 'title', name: 'title', content: this.pages.contact && this.pages.contact.seo ? this.pages.contact.seo.title : 'Contact | Info | Meiden van Holland' },
        { hid: 'og:title', name: 'og:title', content: this.pages.contact && this.pages.contact.seo ? this.pages.contact.seo.title : 'Contact | Info | Meiden van Holland' },
        { hid: 'description', name: 'description', content: this.pages.contact && this.pages.contact.seo ? this.pages.contact.seo.description : 'Heb je een vraag of kom je ergens niet uit? Neem dan contact met op ons op. We reageren bijna altijd binnen één werkdag.'},
        { hid: 'og:description', name: 'og:description', content: this.pages.contact && this.pages.contact.seo ? this.pages.contact.seo.description : 'Heb je een vraag of kom je ergens niet uit? Neem dan contact met op ons op. We reageren bijna altijd binnen één werkdag.' },
        { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/info/contact' },
        { hid: 'keywords', name: 'keywords', content: this.pages.over ? this.pages.contact.seo.keywords : 'Contact, formulier' },
      ]
    }
  },
  data() {
    return {
    }
  },
}
